module.exports = __webpack_public_path__ + "static/media/book_a.cf59ec12.jpg";